import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import mainHelper from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
class KsoftDocumentsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDocumentDetail = (invoiceID) => {
        this.props.history.push(`/document-detail/${invoiceID}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewCustomerPermission = userPermissions.includes('view customer');
        const columns = [
            {
                name:'ID',
                selector:row => row.id,
                sortable:true
            },

            {
                name:'İsim',
                selector:row => row.source_title,
                sortable:true
            },
            {
                name:'Vergi No',
                selector:row => row.source_id,
                sortable:true
            },

            {
                name:'Fatura No',
                selector:row => row.documentId,
                sortable:true
            },
            {
                name:'Fatura Tutarı',
                selector:row => row.invoice_total,
                sortable:true
            },
            {
                name:'Fatura Kesim Tarihi',
                selector:row => row.document_issue_date ? mainHelper.dateFormat(row.document_issue_date).split(' 03')[0] : ""
            },



        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/ksoft/documents"}
                columns={columns}
                onRowClicked={userHasViewCustomerPermission ? row => this.handleDocumentDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(KsoftDocumentsTable));
